import { apiClient } from '@/shared/services/client'
import type {
  Contacto,
  ContactoListResponse,
  ContactosFilters,
  ContactoUpdateInput,
  Stats,
} from '@/modules/bd-unificada/types/contacto'

const BASE = '/bd-unificada/contactos'

export async function getContactos(filters?: ContactosFilters): Promise<ContactoListResponse> {
  const response = await apiClient.get<ContactoListResponse>(`${BASE}/`, { params: filters })
  return response.data
}

export async function buscarContactos(q: string): Promise<Contacto[]> {
  const response = await apiClient.get<Contacto[]>(`${BASE}/buscar`, { params: { q } })
  return response.data
}

export async function getStats(): Promise<Stats> {
  const response = await apiClient.get<Stats>(`${BASE}/stats`)
  return response.data
}

export async function getEspecialidades(): Promise<string[]> {
  const response = await apiClient.get<string[]>(`${BASE}/especialidades`)
  return response.data
}

export async function getContacto(id: string): Promise<Contacto> {
  const response = await apiClient.get<Contacto>(`${BASE}/${id}`)
  return response.data
}

export async function updateContacto(id: string, data: ContactoUpdateInput): Promise<Contacto> {
  const response = await apiClient.put<Contacto>(`${BASE}/${id}`, data)
  return response.data
}

export async function deleteContacto(id: string): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.delete(`${BASE}/${id}`)
  return response.data
}

export async function exportarContactosCsv(filters?: ContactosFilters): Promise<Blob> {
  const { pagina: _pagina, por_pagina: _porPagina, ...params } = filters ?? {}
  const response = await apiClient.get(`${BASE}/exportar`, {
    params,
    responseType: 'blob',
  })
  return response.data
}
